const tagsSelector = '.js-tags';

window.initSliderTags = function () {
    $(function () {
        $(tagsSelector).each(function () {
            const listEl = $(this).find('.tags__list')[0];
            const hasScrollbar = listEl.scrollWidth > listEl.clientWidth;
            if (hasScrollbar) {
                $(this).addClass('tags--toggleable');
            }
        });

        $B.on('click', '.js-tags-showall', function (e) {
            e.preventDefault();
            $(this).parents(tagsSelector).addClass('tags--opened')
        });
    });
}
initSliderTags();
